import React, { useState } from "react";
import { menuTypes, getShortTitle } from "common/menuTypes";
import classnames from "classnames";
import {
  BotanicIcon,
  InformationalModal,
  RadioGroup,
  Radio,
} from "@leafly-com/frontend-components";

const MenuTypeButton = ({
  medical,
  handleMenuTypeIsMedicalChange,
  color,
}: {
  medical: boolean;
  handleMenuTypeIsMedicalChange: (value: boolean) => void;
  color: string;
}) => {
  const [opened, setOpened] = useState(false);

  const toggleMenuTypesOpened = () => {
    setOpened(!opened);
  };

  const handleMenuTypeChange = (value: boolean) => {
    handleMenuTypeIsMedicalChange(value);

    toggleMenuTypesOpened();
  };

  const modalLabelId = "choose-menu-type-label";

  const modalOptions = [
    { value: false, label: menuTypes.rec.longTitle },
    { value: true, label: `${menuTypes.med.longTitle}*` },
  ];

  return (
    <>
      <div
        className={classnames(
          "ml-md px-md py-sm text-sm rounded flex font-bold flex-initial",
          {
            "bg-green text-white": color === "green",
            "bg-leafly-white text-black": color === "white",
          }
        )}
        onClick={toggleMenuTypesOpened}
        onKeyPress={toggleMenuTypesOpened}
        role="button"
        tabIndex={0}
        data-testid="menu-search-type"
      >
        <div>Menu:</div>

        <div
          className={classnames("ml-md flex", {
            "text-white": color === "green",
            "text-green": color === "white",
          })}
        >
          <div>{getShortTitle(medical)}</div>

          <BotanicIcon name="arrow_drop_down" />
        </div>
      </div>

      {opened && (
        <InformationalModal
          aria-labelledby={modalLabelId}
          onDismissed={toggleMenuTypesOpened}
        >
          <div id={modalLabelId} className="heading--l">
            Choose your menu
          </div>

          <RadioGroup name={"menuType"} className="mt-xl">
            {modalOptions.map(({ value, label }) => (
              <Radio
                key={value}
                id={label}
                checked={medical === value}
                label={label}
                className="mb-lg"
                onChange={() => {
                  handleMenuTypeChange(value);
                }}
                onClick={() => {
                  handleMenuTypeChange(value);
                }}
                data-testid={`menu-search-type-option-${value}`}
              />
            ))}
          </RadioGroup>

          <div className="mt-xl">
            *You need a valid medical ID to shop from a medical menu. Your ID
            number is required at checkout.
          </div>

          <div className="mt-xl">
            <span className="font-bold">Good news:</span> You can choose to save
            your med ID to your Leafly profile for faster checkout.
          </div>
        </InformationalModal>
      )}
    </>
  );
};

export default MenuTypeButton;
